/**
 * Centralized status → Tailwind badge class mapping.
 * Replaces nested-ternary usages across admin components.
 */

const CATERING_STATUS_STYLES = {
  accepted: 'bg-blue-100 text-blue-700',
  confirmed: 'bg-blue-100 text-blue-700',
  completed: 'bg-stone-200 text-stone-700',
  rejected: 'bg-red-100 text-red-700',
  pending: 'bg-yellow-100 text-yellow-700',
};

const SUBSCRIPTION_STATUS_STYLES = {
  accepted: 'bg-blue-100 text-blue-700',
  active: 'bg-green-100 text-green-700',
  completed: 'bg-stone-200 text-stone-700',
  rejected: 'bg-red-100 text-red-700',
  pending: 'bg-yellow-100 text-yellow-700',
};

const ORDER_STATUS_STYLES = {
  approved: 'bg-green-100 text-green-700',
  completed: 'bg-stone-200 text-stone-700',
  cancelled: 'bg-red-100 text-red-700',
  pending: 'bg-yellow-100 text-yellow-700',
};

export const getCateringStatusStyle = (status) =>
  CATERING_STATUS_STYLES[status] || CATERING_STATUS_STYLES.pending;

export const getSubscriptionStatusStyle = (status) =>
  SUBSCRIPTION_STATUS_STYLES[status] || SUBSCRIPTION_STATUS_STYLES.pending;

export const getOrderStatusStyle = (status) =>
  ORDER_STATUS_STYLES[status] || ORDER_STATUS_STYLES.pending;
